export let FlexModifiers;

(function (FlexModifiers) {
  FlexModifiers["flex"] = "flex";
  FlexModifiers["inline-flex"] = "inline-flex";
  FlexModifiers["spacer-none"] = "spacer-none";
  FlexModifiers["spacer-xs"] = "spacer-xs";
  FlexModifiers["spacer-sm"] = "spacer-sm";
  FlexModifiers["spacer-md"] = "spacer-md";
  FlexModifiers["spacer-lg"] = "spacer-lg";
  FlexModifiers["spacer-xl"] = "spacer-xl";
  FlexModifiers["spacer-2xl"] = "spacer-2xl";
  FlexModifiers["spacer-3xl"] = "spacer-3xl";
  FlexModifiers["space-items-none"] = "space-items-none";
  FlexModifiers["space-items-xs"] = "space-items-xs";
  FlexModifiers["space-items-sm"] = "space-items-sm";
  FlexModifiers["space-items-md"] = "space-items-md";
  FlexModifiers["space-items-lg"] = "space-items-lg";
  FlexModifiers["space-items-xl"] = "space-items-xl";
  FlexModifiers["space-items-2xl"] = "space-items-2xl";
  FlexModifiers["space-items-3xl"] = "space-items-3xl";
  FlexModifiers["grow"] = "grow";
  FlexModifiers["shrink"] = "shrink";
  FlexModifiers["flex-1"] = "flex-1";
  FlexModifiers["flex-2"] = "flex-2";
  FlexModifiers["flex-3"] = "flex-3";
  FlexModifiers["flex-4"] = "flex-4";
  FlexModifiers["flex-default"] = "flex-default";
  FlexModifiers["flex-none"] = "flex-none";
  FlexModifiers["column"] = "column";
  FlexModifiers["column-reverse"] = "column-reverse";
  FlexModifiers["row"] = "row";
  FlexModifiers["row-reverse"] = "row-reverse";
  FlexModifiers["wrap"] = "wrap";
  FlexModifiers["wrap-reverse"] = "wrap-reverse";
  FlexModifiers["nowrap"] = "nowrap";
  FlexModifiers["align-right"] = "align-right";
  FlexModifiers["align-left"] = "align-left";
  FlexModifiers["align-self-flex-start"] = "align-self-flex-start";
  FlexModifiers["align-self-flex-end"] = "align-self-flex-end";
  FlexModifiers["align-self-center"] = "align-self-center";
  FlexModifiers["align-self-baseline"] = "align-self-baseline";
  FlexModifiers["align-self-stretch"] = "align-self-stretch";
  FlexModifiers["justify-content-flex-end"] = "justify-content-flex-end";
  FlexModifiers["justify-content-center"] = "justify-content-center";
  FlexModifiers["justify-content-space-between"] = "justify-content-space-between";
  FlexModifiers["justify-content-space-around"] = "justify-content-space-around";
  FlexModifiers["justify-content-space-evenly"] = "justify-content-space-evenly";
  FlexModifiers["justify-content-flex-start"] = "justify-content-flex-start";
  FlexModifiers["full-width"] = "full-width";
  FlexModifiers["align-items-flex-start"] = "align-items-flex-start";
  FlexModifiers["align-items-flex-end"] = "align-items-flex-end";
  FlexModifiers["align-items-stretch"] = "align-items-stretch";
  FlexModifiers["align-items-baseline"] = "align-items-baseline";
  FlexModifiers["align-content-flex-start"] = "align-content-flex-start";
  FlexModifiers["align-content-flex-end"] = "align-content-flex-end";
  FlexModifiers["align-content-center"] = "align-content-center";
  FlexModifiers["align-content-stretch"] = "align-content-stretch";
  FlexModifiers["align-content-space-between"] = "align-content-space-between";
  FlexModifiers["align-content-space-around"] = "align-content-space-around";
})(FlexModifiers || (FlexModifiers = {}));

export let FlexItemModifiers;

(function (FlexItemModifiers) {
  FlexItemModifiers["spacer-none"] = "spacer-none";
  FlexItemModifiers["spacer-xs"] = "spacer-xs";
  FlexItemModifiers["spacer-sm"] = "spacer-sm";
  FlexItemModifiers["spacer-md"] = "spacer-md";
  FlexItemModifiers["spacer-lg"] = "spacer-lg";
  FlexItemModifiers["spacer-xl"] = "spacer-xl";
  FlexItemModifiers["spacer-2xl"] = "spacer-2xl";
  FlexItemModifiers["spacer-3xl"] = "spacer-3xl";
  FlexItemModifiers["grow"] = "grow";
  FlexItemModifiers["shrink"] = "shrink";
  FlexItemModifiers["flex-1"] = "flex-1";
  FlexItemModifiers["flex-2"] = "flex-2";
  FlexItemModifiers["flex-3"] = "flex-3";
  FlexItemModifiers["flex-4"] = "flex-4";
  FlexItemModifiers["flex-default"] = "flex-default";
  FlexItemModifiers["flex-none"] = "flex-none";
  FlexItemModifiers["align-right"] = "align-right";
  FlexItemModifiers["align-left"] = "align-left";
  FlexItemModifiers["align-self-flex-start"] = "align-self-flex-start";
  FlexItemModifiers["align-self-flex-end"] = "align-self-flex-end";
  FlexItemModifiers["align-self-center"] = "align-self-center";
  FlexItemModifiers["align-self-baseline"] = "align-self-baseline";
  FlexItemModifiers["align-self-stretch"] = "align-self-stretch";
  FlexItemModifiers["full-width"] = "full-width";
})(FlexItemModifiers || (FlexItemModifiers = {}));

export let FlexBreakpoints;

(function (FlexBreakpoints) {
  FlexBreakpoints["sm"] = "sm";
  FlexBreakpoints["md"] = "md";
  FlexBreakpoints["lg"] = "lg";
  FlexBreakpoints["xl"] = "xl";
  FlexBreakpoints["2xl"] = "2xl";
})(FlexBreakpoints || (FlexBreakpoints = {}));